import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'
import { logToSentry } from './hostHelpers'

export const simpleFetchWithLogging = simpleFetch.bind((error, url) => {
  logToSentry(error, { url })
  throw error
}) as typeof simpleFetch
